import React from "react";
import { JudgePageIcon } from "~/assets/svg/PageIntroIcon";
import { Trans, useTranslation } from "react-i18next";

const PageIntro = () => {
	const { t } = useTranslation();
	return (
		<div className="pageIntro">
			<JudgePageIcon />
			<div className="content">
				<h3>
					<Trans
						i18nKey="pages.round.RoundList.component.PageIntro.h3"
						components={[<b />]}
					/>
				</h3>
				<p className="pre">{t("pages.round.RoundList.component.PageIntro.p")}</p>
			</div>
		</div>
	);
};

export default PageIntro;
